import React from "react";
import "./Franchise.scss"
import FranchiseHero from "./FranchiseHero";
import FranchiseInvestors from "./FranchiseInvestors";
import FranchiseStartup from "./FranchiseStartup";
import FranchiseForm from "./FranchiseForm";
import MenuNavbarMini from "../../../components/Navbar/MenuNavbarMini";
import MenuFooter from "../../../components/Footer/MenuFooter/MenuFooter";
import { sortByOrderAscending } from "../../../../Hospitality/helper/helper";
import { useSelector } from "react-redux";
const Franchise = () => {

    const pages = useSelector((state) => state.companyData.pages)
    const page = pages?.find((page) => page.PageId === "franchise")

    const Components = page?.Components || []
    const getComponents = (component) => {
        switch (component.ID) {
            case "FranchiseHero":
                return <FranchiseHero components={component.Components} />
            case "FranchiseInvestors":
                return <FranchiseInvestors components={component.Components} />
            case "FranchiseStartup":
                return <FranchiseStartup components={component.Components} />

            case "FranchiseForm":
                return <FranchiseForm components={component.Components} />
            default:
                return <div />
        }

    }
    return (
        <div className="Franchise">
            <MenuNavbarMini />
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div className="EcommerceHome-container" key={key}>
                    {getComponents(component)}
                </div>)
            })}
            <MenuFooter />
        </div>
    )
}
export default Franchise